import type {SelectV2} from '../Select.v2';

type Scheme = {
  multi: boolean;
  single: boolean;
};

const blurScheme: Scheme = {
  multi: false,
  single: true,
};

const closeScheme: Scheme = {
  multi: false,
  single: true,
};

export const useCloseBehaviour = (
  props: Pick<
    SelectV2.Props,
    'blurInputOnSelect' | 'closeMenuOnSelect' | 'isMulti'
  >,
) => {
  const schemeKey = props.isMulti ? 'multi' : ('single' as const);

  const blurOnSelect = props.blurInputOnSelect ?? blurScheme[schemeKey];
  const closeOnSelect = props.closeMenuOnSelect ?? closeScheme[schemeKey];

  return {blurOnSelect, closeOnSelect};
};
